import { CustomAppLayout } from '../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useState } from 'react';
import { useRouter } from '../../../router';
const _preserve = React.version;
//import { useStore } from '../store';
import { useGlobalState } from '../../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { Alert, Button, Checkbox, ExpandableSection, Form, FormField, Input, SelectProps, SpaceBetween } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import BadgeCustom from '../../../../../components/extras/BadgeCustom';
import Favorites from '../../../../../components/extras/Favorites';
import SelectCheck from '../../../../../components/selects/selectChecks';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { ItemCheck, ItemnCheckParametersGroup, OptionDefinition } from '../../../../../resources/types';
import { addNotificationStatus, buildBreadcrumbItems, getCookie, getUrlVersion, setData, setLoading, setParameters } from '../../../../commons/functions';



interface OptionGroup {
    label: string;
    options: OptionDefinition[];
}

export const MembersEDVRequestChecksPage = () => {
    //const storeAdmin = useStoreAdmin();

    useGlobalState();
    const { navigate } = useRouter();

    const { idUser, menu, parameters, data } = useGlobalState();


    const [checks, setChecks] = useState<ItemCheck[]>([]);

    const [selectedOption, setSelectedOption] = React.useState<SelectProps.Option | null>(null);
    const [checksOptions, setChecksOptions] = useState<OptionDefinition[]>([]);
    const [checkParameters, setCheckParameters] = useState<ItemnCheckParametersGroup[]>([]);
    const [selectCheckParameters, setSelectCheckParameters] = useState<OptionGroup[]>([]);
    const [selectedCheckParameters, setSelectedCheckParameters] = React.useState<SelectProps.Option[]>([]);
    const [check, setCheck] = useState<ItemCheck | null>(null);
    const [request1, setRequest1] = useState<boolean>(false);
    const [request2, setRequest2] = useState<boolean>(false);
    const [request3, setRequest3] = useState<boolean>(false);
    const [idLastInstructor, setIdLastInstructor] = useState<number>(0);
    const handleGetChecks = async () => {
        try {

            setLoading(true);
            //console.log(check)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/global/checks/list',
                    'JWT': getCookie("JWT"),

                },
                body: JSON.stringify({
                    limit: 1000,
                    columns: "idCheck, [check], equipmentCheck",
                    orderBy: "[check]",
                    order: "asc"
                })
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const data = await response.json();

            if (data.code === 0) {
                if (data.checks) {

                    setChecks(data.checks);
                }
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);

        }
    };
    useEffect(() => {
        handleGetChecks()
    }, []);
    const isCheckDone = (check: ItemCheck): boolean => {
        console.log(check.checks)

        if (check.checks && check.isRepeat === 0 && check.checks?.length > 0) {
            return true;
        }
        return false;
    }
    const handleAddCheck = async () => {
        try {

            setLoading(true);
            //console.log(check)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/user/checks/requests/update',
                    'JWT': getCookie("JWT"),

                },
                body: JSON.stringify({
                    idRequest: 0,
                    idCheck: check?.idCheck,
                    idUser: idUser,
                    obsPilot: check?.obsPilot,
                    requestToLastInstructor: request3,
                    statusRequest: 0,
                })
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const data = await response.json();
            addNotificationStatus(data, setData);

            if (data.code === 0) {
                setCheck(null);
                setRequest2(false);
                setRequest1(false);
                setParameters({ ...parameters, idCheck: 0 });
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);

        }
    };
    const handleGetCheck = async (idCheck: number) => {
        try {
            setLoading(true);
            setCheck(null);
            setRequest2(false);
            setRequest1(false);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/user/checks/get',
                    'JWT': getCookie("JWT"),

                },
                body: JSON.stringify({
                    history: true,
                    idCheck: idCheck
                })
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const data = await response.json();

            if (data.code === 0) {
                if (data.check) {
                    let idCheckParameters: number[] = []
                    const options = data.check.jsonParams.map((param: { checkEval: any; idCheckParameter: any; }) => ({
                        label: param.checkEval,
                        value: param.idCheckParameter
                    }));

                    const options2 = data.check.jsonParams.map((param: { checkEval: any; idCheckParameter: any; }) => {
                        idCheckParameters.push(Number(param.idCheckParameter))
                    });
                    data.check.idCheckParameters = idCheckParameters
                    setCheck(data.check)
                    setSelectedCheckParameters(options)
                    setIdLastInstructor(data.check.idLastInstructor)
                    //setCheckParameters(data.check.jsonParam)
                }
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);

        }
    };
    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween size="s">
                    <Form
                        actions={
                            check && check.idCheck > 0 && !isCheckDone(check) && (
                                <Button variant="primary" disabled={!request2}
                                    onClick={() => {
                                        handleAddCheck();
                                    }}
                                >Enviar solicitud</Button>
                            )
                        }
                        header={
                            <Header variant="h1" actions={<Favorites />}>Solicitar chequeo</Header>
                        }>
                        <SpaceBetween size="xs" direction='vertical'>

                            <div style={{ width: 250 }}>
                                <SelectCheck single={true}
                                    disabled={!checks || checks.length === 0}
                                    checks={checks}

                                    value={parameters.idCheck}
                                    onSelect={(idCheck) => {
                                        handleGetCheck(idCheck || 0);
                                    }}
                                />
                            </div>
                            {check && check.idCheck > 0 && (
                                <SpaceBetween size="s">
                                    <FormField label={check.check}>
                                        <div
                                            style={{ marginBottom: '16px' }}
                                            dangerouslySetInnerHTML={{
                                                __html: check.chequeo.replace(";;;", "<br>"),
                                            }}
                                        />
                                    </FormField>
                                    {check.jsonParams && (
                                        <ExpandableSection headerText="Cartilla de evaluación">
                                            <ul>
                                                {

                                                    check.jsonParams.map((param: { checkEval: string; detalleEval: string }, index: number) => (
                                                        <li>{param.checkEval}</li>
                                                    ))
                                                }

                                            </ul>
                                        </ExpandableSection>
                                    )}
                                    {check.requisitosCondicion !== "" && (
                                        <FormField label="Requisitos/Condiciones">
                                            <div
                                                style={{ marginBottom: '16px' }}
                                                dangerouslySetInnerHTML={{
                                                    __html: check.requisitosCondicion.replace(";;;", "<br>"),
                                                }}
                                            />
                                        </FormField>
                                    )}
                                    {check.curso !== "" && (
                                        <FormField label="Curso">

                                            <div
                                                style={{ marginBottom: '16px' }}
                                                dangerouslySetInnerHTML={{
                                                    __html: check.curso.replace(";;;", "<br>"),
                                                }}
                                            />
                                        </FormField>

                                    )}
                                    {check.habilitacion !== "" && (
                                        <FormField label="Habilitación">

                                            <div
                                                style={{ marginBottom: '16px' }}
                                                dangerouslySetInnerHTML={{
                                                    __html: check.habilitacion.replace(";;;", "<br>"),
                                                }}
                                            />
                                        </FormField>

                                    )}
                                    {check.requisitosFamiliarizacion !== "" && (
                                        <FormField label="Requisitos/Familiarización">

                                            <div
                                                style={{ marginBottom: '16px' }}
                                                dangerouslySetInnerHTML={{
                                                    __html: check.requisitosFamiliarizacion.replace(";;;", "<br>"),
                                                }}
                                            />
                                        </FormField>

                                    )}
                                    {check.observaciones !== "" && (
                                        <FormField label="Observaciones">

                                            <div
                                                style={{ marginBottom: '16px' }}
                                                dangerouslySetInnerHTML={{
                                                    __html: check.observaciones.replace(";;;", "<br>"),
                                                }}
                                            />
                                        </FormField>
                                    )}
                                    {(check.isRepeat === 0 && check.checks && check.checks?.length > 0) && (
                                        <Alert type="warning" header="Atención" dismissible={true}>
                                            Usted ya ha realizado este chequeo con anterioridad y lo ha aprobado, por lo que no puede ser solicitado nuevamente.
                                        </Alert>

                                    )}

                                    {(check.isRepeat === 1 && check.checks && check.checks?.length > 0) && (

                                        <Header variant="h3"
                                            description={
                                                <SpaceBetween size="l" direction='horizontal'>
                                                    {check.checks.map((chk: any) => (
                                                        <BadgeCustom color='blue'>{chk.dateResult}</BadgeCustom>
                                                    ))}

                                                </SpaceBetween>
                                            }
                                        >Historial de chequeos realizados</Header>


                                    )}
                                    {((check.isRepeat === 0 && check.checks?.length === 0) || check.isRepeat === 1) && (
                                        <>
                                            <Checkbox checked={request1}
                                                onChange={({ detail }) => {
                                                    setRequest1(detail.checked)
                                                    if (detail.checked === false) {
                                                        setRequest2(false)
                                                    }
                                                }}
                                            >Solicitar chequeo</Checkbox>

                                            <Checkbox checked={request2}
                                                onChange={({ detail }) => {
                                                    setRequest2(detail.checked)
                                                }}
                                                disabled={!request1}>Declaro cumplir los requisitos solicitados y entiendo que de no hacerlo será considerado una falta grave.</Checkbox>

                                            {/*
                                            idLastInstructor !== 0 && data &&  (

                                                <Checkbox checked={request3}
                                                    onChange={({ detail }) => {
                                                        setRequest3(detail.checked)
                                                    }}
                                                    disabled={!request1}>Solicitar al instructor <strong>{getUser(idLastInstructor, data)?.displayName}</strong> asignado antes de su última anulación?</Checkbox>
                                            )
                                            */
                                            }
                                            <FormField label="Observaciones" constraintText="Opcional">
                                                <Input
                                                    disabled={!request2}
                                                    value={check.obsPilot} onChange={(detail) => {
                                                        setCheck((prev) => ({
                                                            ...prev,
                                                            obsPilot: detail.detail.value,
                                                        } as ItemCheck));
                                                    }} />
                                            </FormField>
                                        </>
                                    )}
                                </SpaceBetween>

                            )}
                        </SpaceBetween>
                    </Form>
                </SpaceBetween >
            }
        />
    );
};
